export default {
  cookiecontent: `당사는 웹사이트 및 기타 온라인 서비스에서 쿠키를 사용하여 서비스가 정상적으로 작동하도록 하고, 귀하가 웹사이트를 최대한 활용할 수 있도록 돕습니다. 또한 웹사이트의 사용 방식과 상호작용을 분석하고, 소셜 미디어 기능을 제공하기 위해 쿠키를 사용합니다. 귀하는 이러한 쿠키를 수락하거나 거부하거나, 허용할 쿠키 유형을 직접 설정할 수 있습니다. 단, 일부 쿠키를 거부할 경우 웹사이트 기능이 제한될 수 있습니다. 
    <a href="/cookie" target="_blank">《쿠키 정책》</a>`,
  同意: "동의",
  拒绝: "거부",
  Cookie政策: "쿠키 정책",
  本Cookie政策说明EBCFinancial: `본 쿠키 정책은 EBC Financial Group(이하 “EBC”, “당사”)이 웹사이트 [www.ebc.com] (이하 “당사 웹사이트”)에서 쿠키 및 유사한 기술을 어떻게 사용하는지를 설명합니다.`,
  什么是Cookie: "1. 쿠키란 무엇인가요?",
  Cookie是当您浏览EBC: `쿠키는 귀하가 EBC 웹사이트를 방문할 때 귀하의 장치(예: 컴퓨터, 모바일 등)에 저장되는 소형 텍스트 파일입니다. 쿠키는 일반적으로 웹사이트 성능 향상과 사이트 운영자에게 정보를 제공하는 데 사용됩니다.
`,
  您可透过以下网站了解更多: "자세한 정보는 다음 링크에서 확인할 수 있습니다:",
  我们使用的Cookie类型: "2. 당사가 사용하는 쿠키 유형",
  tabletop: "당사 웹사이트에서는 다음과 같은 유형의 쿠키를 사용합니다.",
  Cookie类型: "쿠키 유형",
  说明: "설명",
  必要Cookie: "필수 쿠키",
  此类Cookie是网站正常运作所必需: `웹사이트의 정상적인 작동에 필수적인 쿠키로, 비활성화할 수 없습니다. 주로 양식 작성이나 개인정보 설정 등 귀하의 활동에 따라 설정됩니다. 브라우저에서 차단할 수 있으나 일부 기능이 제한될 수 있습니다.`,
  效能分析Cookie: "성능(분석) 쿠키",
  此类Cookie协助我们计算访客数与流量来源: `방문 수 및 트래픽 출처를 파악하여 사이트 성능과 콘텐츠 개선에 도움을 줍니다. 어떤 페이지가 인기가 있는지, 방문자의 사이트 이용 경로 등을 파악합니다.`,
  功能性Cookie: "기능 쿠키",
  使网站能提供更进阶的功能与个人化体验: `고급 기능 및 개인 맞춤형 서비스를 제공하며, 당사 또는 제3자 서비스 제공자가 설정할 수 있습니다. 이 쿠키를 비활성화하면 일부 기능이 작동하지 않을 수 있습니다.`,
  tablebottom: "쿠키는 웹사이트, 상품 및 신청 절차를 최대한 활용할 수 있게 해주는 중요한 도구입니다. 쿠키 사용을 거부하거나 브라우저 설정을 통해 쿠키를 차단할 경우 일부 서비스 이용이 제한될 수 있습니다.",
  如何管理Cookie: "3. 쿠키 관리 방법",
  您有权决定是否接受Cookie:
    "귀하는 쿠키 수락 여부를 직접 결정할 수 있습니다. 대부분의 브라우저에서는 다음 기능을 제공합니다:",
  查看装置上已安装的Cookie: "설치된 쿠키 보기",
  删除Cookie: "쿠키 삭제",
  封锁Cookie: "쿠키 차단",
  设定特定网站的Cookie偏好: "특정 웹사이트에 대한 쿠키 설정",
  详细操作请参阅您的浏览器说明页:
    "자세한 방법은 아래 링크를 참고하세요:",
  同意h2: "4. 동의",
  当您使用本网站: `귀하가 본 웹사이트를 사용하는 경우, 별도로 브라우저에서 쿠키를 차단하지 않는 한 위에 명시된 유형의 쿠키가 귀하의 장치에 저장되고 본 정책에 따라 관련 데이터가 사용되는 것에 동의한 것으로 간주됩니다.`,
  政策更新: "5. 정책 업데이트",
  本Cookie政策可能因应实务或法律改变而更新: `본 쿠키 정책은 실무 또는 관련 법률 변경에 따라 수시로 업데이트될 수
          있습니다. 중요한 변경 사항이 있을 경우, 당사 웹사이트에 공지를 통해
          알릴 것입니다.
          <br />
          쿠키 사용 또는 본 정책에 대한 문의사항이 있는 경우 다음 이메일로
          연락해 주세요:
          <a class="a-normal" href="mailto:cs@ebc.com">cs@ebc.com</a>`,
  最后更新时间: "최종 업데이트일: 2025년 6월",
};
